$('.material').find('input').on('focus', function (e) {
    console.log($(e.currentTarget).attr())
    // $(e.currentTarget).attr('data-empty', !e.currentTarget.value);
});